module.exports = __webpack_public_path__ + "img/banco-central.fd7512e1.png";